import { render } from "./profilePatient.vue?vue&type=template&id=27bfe362&scoped=true"
import script from "./profilePatient.vue?vue&type=script&lang=js"
export * from "./profilePatient.vue?vue&type=script&lang=js"

import "./profilePatient.vue?vue&type=style&index=0&id=27bfe362&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bfe362"]])

export default __exports__